import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';

export function useInstantTransferPaywall() {
  const { data: carrierSettings } = useCarrierSettings();
  const isInstantTransferAvailable =
    !!carrierSettings?.superpay.instant_transfer_available;

  return {
    shouldShowUpgradeDialog: !isInstantTransferAvailable,
    isInstantTransferAvailable,
  };
}
